import { createApp } from "vue";
import App from "./App.vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import router from "./router";
import store from './store';
// 添加全局错误处理
const ignoreResizeObserverError = () => {
  window.addEventListener("error", (e) => {
    if (e.message.includes("ResizeObserver")) {
      e.stopImmediatePropagation();
    }
  });
};

const app = createApp(App);
app.use(store);
app.use(Antd);
app.use(router);

// 添加错误处理
ignoreResizeObserverError();

app.mount("#app");
